import { StyleSheet, Dimensions } from 'react-native';

const { width } = Dimensions.get('window');

export const styles = StyleSheet.create({
    card_content: {
        display: 'flex',
        flexDirection: 'row',
        marginHorizontal: 10,
    },
    card_left: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginRight: 5,
    },
    card_right: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginLeft: 5,
    },
});
